<template>
  <section>
    <fieldset
      :disabled="disabled || isScenarioReadonly || isImportedFromLegacy"
    >
      <OperatingParameters />
      <!-- Dual Stack View when Lower Stack is enabled -->
      <div v-if="useLowerStack" class="dual-stack-section">
        <SplitEquipmentView />
      </div>
      <!-- Regular Equipment View when Lower Stack is not enabled -->
      <template v-else>
        <Pumps v-if="!isEspOnShore" v-model:disabled="disabled" />
        <Intakes />
        <Pumps v-if="isEspOnShore" v-model:disabled="disabled" />
        <SealSensorMle v-if="!isEspOnShore" />
        <Motor />
        <SealSensorMle v-if="isEspOnShore" />
        <Cables v-if="isEspOnShore" />
        <SurfaceDrive />
      </template>
    </fieldset>
  </section>
</template>

<script setup lang="ts">
import OperatingParameters from "@/views/scenarios/sizingParameters/OperatingParameters.vue";
import SealSensorMle from "@/views/scenarios/sizingParameters/SealSensorMle.vue";
import { useEditPermissions } from "@/composables/auth/editPermissions";
import Intakes from "@/views/scenarios/sizingParameters/Intakes.vue";
import Cables from "@/views/scenarios/sizingParameters/Cables.vue";
import Motor from "@/views/scenarios/sizingParameters/Motor.vue";
import Pumps from "@/views/scenarios/sizingParameters/Pumps.vue";
import SurfaceDrive from "./sizingParameters/SurfaceDrive.vue";
import SplitEquipmentView from "@/components/scenarios/SplitEquipmentView.vue";
import { computed, ref } from "vue";
import {
  sizingFormKey,
  equipmentFormKey
} from "@/composables/scenarioDetailProvider/scenarioDetailProviderKeys";
import { injectStrict } from "@/utils/utils";
import { Sizing_Pumping_Type_Enum } from "gql/api";

const disabled = ref(false);
const { isScenarioReadonly, isImportedFromLegacy } = useEditPermissions();
const sizingForm = injectStrict(sizingFormKey, null);
const equipmentForm = injectStrict(equipmentFormKey);
const equipment = computed(() => equipmentForm.data.value);

const isEspOnShore = computed(() => {
  return (
    sizingForm?.data.value.pumping_type === Sizing_Pumping_Type_Enum.EspOnShore
  );
});

const useLowerStack = computed(() => {
  const hasLowerEquipStack = equipment.value.has_lower_equip_stack ?? false;
  const useUpperYTool = equipment.value.use_uphole_y_tool ?? false;
  const upperYToolSelected = !!equipment.value.r_uphole_y_tool;
  const useLowerYTool = equipment.value.use_downhole_y_tool ?? false;
  const lowerYToolSelected = !!equipment.value.r_downhole_y_tool;

  return (
    hasLowerEquipStack &&
    useUpperYTool &&
    upperYToolSelected &&
    useLowerYTool &&
    lowerYToolSelected
  );
});
</script>

<style lang="scss" scoped>
.anchor {
  position: relative;
  top: -15vh;
}

.dual-stack-section {
  margin-top: 2rem;
  padding: 1rem 0;
}
</style>
